module.exports = __webpack_public_path__ + "img/setup_low_stock.243fccb8.svg";